import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NotifierService } from '@shared/core/services/notifier.service';
import { TranslocoService } from '@ngneat/transloco';

@Injectable()
export class ServerErrorInterceptor implements HttpInterceptor {
  constructor(private notifier: NotifierService, private translocoService: TranslocoService) {}

  intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status >= 500 && error.status < 600) {
          this.notifier.error(this.translocoService.translate('crmCoreModule.somethingBroke'));
        }

        throw error;
      }),
    );
  }
}
